import { useMemo } from 'react';

import { PortfolioReportData, PortfolioReportMembershipRole } from '../components/Reports/types';

import { useProfile } from './useProfile';

type ReportWithMemberships = {
  ReportMemberships?: PortfolioReportData['ReportMemberships'];
};

/**
 * Custom hook to get the current user's membership role for a specific report
 * @param selectedReport - The report to check membership for
 * @returns PortfolioReportMembershipRole - The user's role in the report (defaults to Viewer if not found)
 */
export function useReportMembershipRole(selectedReport?: ReportWithMemberships | null): PortfolioReportMembershipRole {
  const profile = useProfile();

  const reportMembershipRole = useMemo(() => {
    if (!selectedReport?.ReportMemberships || !profile?.User?.id) {
      return PortfolioReportMembershipRole.Viewer;
    }

    const membership = selectedReport.ReportMemberships.find(
      (rm) => rm.UserID === profile.User.id
    );

    return membership?.Role ?? PortfolioReportMembershipRole.Viewer;
  }, [selectedReport?.ReportMemberships, profile?.User?.id]);

  return reportMembershipRole;
}